<template>
  <div id="formTravel">
    <Topbar @action="fnAction"></Topbar>
    <v-container class="center">
      <v-layout row wrap class="section-container" id="basic">
        <v-flex xs12 class="item">
          <v-form ref="form" v-model="valid">
            <v-container>
              <v-layout row wrap>
                <v-flex xs12 md12 class="item">
                  <div
                    style="
                      width: 100%;
                      text-align: center;
                      margin: 10px 0px -10px 0px;
                    "
                  >
                    {{ $t("params.travel_number") }}:
                    <b
                      >#{{
                        travel.travel_number
                          ? travel.travel_number
                          : nextTravelID
                      }}</b
                    >
                  </div>
                </v-flex>

                <v-flex xs12 class="name">{{ $t("titles.travel") }}</v-flex>

                <v-flex xs6 md6 class="item">
                  <v-switch
                    v-model="travel.bus_private"
                    :label="'params.bus_private' | i18n"
                  ></v-switch>
                </v-flex>

                <v-flex xs6 md6 class="item">
                  <v-select
                    attach
                    v-model="travel.type"
                    :multiple="false"
                    :items="travelTypes"
                    :item-text="'name'"
                    item-value="value"
                    :label="'params.type' | i18n"
                    :disabled="false"
                    attach
                  ></v-select>
                </v-flex>

                <v-flex xs6 md6 class="item">
                  <v-select
                    attach
                    v-model="travel.status"
                    :multiple="false"
                    :items="statusOptions"
                    :item-text="'name'"
                    item-value="value"
                    :label="'params.status' | i18n"
                    :disabled="false"
                  ></v-select>
                </v-flex>

                <v-flex xs6 md6 class="item">
                  <v-select
                    attach
                    v-model="travel.transport_mode"
                    :multiple="false"
                    :items="transport_modes"
                    :item-text="'name'"
                    item-value="id"
                    :label="'params.transport_mode' | i18n"
                    :disabled="false"
                  ></v-select>
                </v-flex>

                <v-flex xs6 md6 class="item">
                  <v-text-field
                    :label="'params.transport_number' | i18n"
                    :value="travel['transport_number'] | checkParam"
                    @change="(v) => (travel['transport_number'] = v)"
                    outline
                  ></v-text-field>
                </v-flex>

                <v-flex xs6 md6 class="item">
                  <v-text-field
                    :label="'params.transport_company' | i18n"
                    :value="travel['transport_company'] | checkParam"
                    @change="(v) => (travel['transport_company'] = v)"
                    outline
                  ></v-text-field>
                </v-flex>
                <v-flex xs6 md6 class="item"> </v-flex>

                <v-flex xs6 md6 class="item">
                  <v-text-field
                    :label="'params.contact_name' | i18n"
                    :value="travel['contact_name'] | checkParam"
                    @change="(v) => (travel['contact_name'] = v)"
                    outline
                  ></v-text-field>
                </v-flex>

                <v-flex xs6 md6 class="item">
                  <v-text-field
                    :label="'params.contact_phone' | i18n"
                    :value="travel['contact_phone'] | checkParam"
                    @change="(v) => (travel['contact_phone'] = v)"
                    outline
                  ></v-text-field>
                </v-flex>

                <v-flex xs6 md6 class="item">
                  <v-text-field
                    :label="'params.cost' | i18n"
                    :value="travel['cost'] | checkParam"
                    @change="(v) => (travel['cost'] = v)"
                    outline
                    min="0"
                    step=".01"
                    type="number"
                  ></v-text-field>
                </v-flex>
                <v-flex xs6 md6 class="item"> </v-flex>

                <v-flex xs12 class="name">{{ $t("params.origin") }}</v-flex>
                <v-flex xs6 md6 class="item">
                  <v-select
                    attach
                    v-model="originType"
                    :multiple="false"
                    :items="locationOptions"
                    :item-text="'name'"
                    item-value="value"
                    :label="'params.type' | i18n"
                    @change="cleanPlace('origin', originType)"
                    :disabled="false"
                  ></v-select>
                </v-flex>

                <template v-if="originType != null && originType != '0'">
                  <v-flex xs6 md6 class="item">
                    <v-select
                      attach
                      v-model="travel.origin.entity_id"
                      :multiple="false"
                      :items="Object.values(originLocations)"
                      :item-text="'name'"
                      item-value="id"
                      :label="'params.origin_name' | i18n"
                      :disabled="originType == null"
                    ></v-select>
                  </v-flex>
                </template>

                <template v-else-if="originType != null && originType == '0'">
                  <v-flex xs6 md6 class="item">
                    <v-text-field
                      :label="'params.origin_name' | i18n"
                      :value="travel.origin.name | checkParam"
                      @change="(v) => (travel.origin.name = v)"
                      outline
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs6 md6 class="item">
                    <v-text-field
                      :label="'params.address' | i18n"
                      :value="travel.origin.address | checkParam"
                      @change="(v) => (travel.origin.address = v)"
                      outline
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs6 md6 class="item">
                    <v-text-field
                      :label="'params.origin_city' | i18n"
                      :value="travel.origin.city | checkParam"
                      @change="(v) => (travel.origin.city = v)"
                      outline
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs6 md6 class="item">
                    <v-text-field
                      :label="'params.latitud' | i18n"
                      :value="travel.origin.latitud | checkParam"
                      @change="(v) => (travel.origin.latitud = v)"
                      outline
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs6 md6 class="item">
                    <v-text-field
                      :label="'params.longitud' | i18n"
                      :value="travel.origin.longitud | checkParam"
                      @change="(v) => (travel.origin.longitud = v)"
                      outline
                    ></v-text-field>
                  </v-flex>
                </template>

                <template v-else>
                  <v-flex xs6 md6 class="item"></v-flex>
                </template>

                <v-flex xs6 md6 class="item">
                  <v-menu
                    v-model="dialog_origin_date"
                    autocomplete="new-text"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        prepend-icon="event"
                        v-model="travel.parsedOriginDate"
                        :label="$t('params.origin_date')"
                        @click:prepend="dialog_origin_date = true"
                        @click="dialog_origin_date = true"
                        :placeholder="'DD/MM/YYYY'"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="travel.origin.date"
                      color="blue-grey lighten-2"
                      @input="(dialog_origin_date = false), formatOriginDate()"
                      :first-day-of-week="1"
                      locale="ca"
                    ></v-date-picker>
                  </v-menu>
                </v-flex>

                <v-flex xs6 md6 class="item">
                  <v-menu
                    ref="menu"
                    v-model="dialog_origin_hour"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    :return-value.sync="origin_time"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                    max-width="290px"
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        prepend-icon="access_time"
                        v-model="travel.origin.hour"
                        :label="$t('params.origin_hour')"
                        @click:prepend="dialog_origin_hour = true"
                        @click="dialog_origin_hour = true"
                        :placeholder="'HH:MM'"
                      ></v-text-field>
                    </template>
                    <v-time-picker
                      v-if="dialog_origin_hour"
                      format="24hr"
                      color="blue-grey lighten-2"
                      v-model="travel.origin.hour"
                      full-width
                      @click:minute="$refs.menu.save(origin_time)"
                      :rules="[(value) => !!value || $t('rules.required')]"
                    ></v-time-picker>
                  </v-menu>
                </v-flex>

                <v-flex xs12 class="name">{{
                  $t("params.destination")
                }}</v-flex>
                <v-flex xs6 md6 class="item">
                  <v-select
                    attach
                    v-model="destinationType"
                    :multiple="false"
                    :items="locationOptions"
                    :item-text="'name'"
                    item-value="value"
                    :label="'params.type' | i18n"
                    @change="cleanPlace('destination', destinationType)"
                    :disabled="false"
                  ></v-select>
                </v-flex>

                <template
                  v-if="destinationType != null && destinationType != '0'"
                >
                  <v-flex xs6 md6 class="item">
                    <v-select
                      attach
                      v-model="travel.destination.entity_id"
                      :multiple="false"
                      :items="Object.values(destinationLocations)"
                      :item-text="'name'"
                      item-value="id"
                      :label="'params.destination_name' | i18n"
                      :disabled="destinationType == null"
                    ></v-select>
                  </v-flex>
                </template>

                <template
                  v-else-if="destinationType != null && destinationType == '0'"
                >
                  <v-flex xs6 md6 class="item">
                    <v-text-field
                      :label="'params.destination_name' | i18n"
                      :value="travel.destination.name | checkParam"
                      @change="(v) => (travel.destination.name = v)"
                      outline
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs6 md6 class="item">
                    <v-text-field
                      :label="'params.address' | i18n"
                      :value="travel.destination.address | checkParam"
                      @change="(v) => (travel.destination.address = v)"
                      outline
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs6 md6 class="item">
                    <v-text-field
                      :label="'params.destination_city' | i18n"
                      :value="travel.destination.city | checkParam"
                      @change="(v) => (travel.destination.city = v)"
                      outline
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs6 md6 class="item">
                    <v-text-field
                      :label="'params.latitud' | i18n"
                      :value="travel.destination.latitud | checkParam"
                      @change="(v) => (travel.destination.latitud = v)"
                      outline
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs6 md6 class="item">
                    <v-text-field
                      :label="'params.longitud' | i18n"
                      :value="travel.destination.longitud | checkParam"
                      @change="(v) => (travel.destination.longitud = v)"
                      outline
                    ></v-text-field>
                  </v-flex>
                </template>

                <template v-else>
                  <v-flex xs6 md6 class="item"></v-flex>
                </template>

                <v-flex xs6 md6 class="item">
                  <v-menu
                    v-model="dialog_destination_date"
                    autocomplete="new-text"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        prepend-icon="event"
                        v-model="travel.parsedDestinationDate"
                        :label="$t('params.destination_date')"
                        @click:prepend="dialog_destination_date = true"
                        @click="dialog_destination_date = true"
                        :placeholder="'DD/MM/YYYY'"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="travel.destination.date"
                      color="blue-grey lighten-2"
                      @input="
                        (dialog_destination_date = false),
                          formatDestinationDate()
                      "
                      :first-day-of-week="1"
                      locale="ca"
                    ></v-date-picker>
                  </v-menu>
                </v-flex>

                <v-flex xs6 md6 class="item">
                  <v-menu
                    ref="menu"
                    v-model="dialog_destination_hour"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    :return-value.sync="destination_time"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                    max-width="290px"
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        prepend-icon="access_time"
                        v-model="travel.destination.hour"
                        :label="$t('params.destination_hour')"
                        @click:prepend="dialog_destination_hour = true"
                        @click="dialog_destination_hour = true"
                        :placeholder="'HH:MM'"
                      ></v-text-field>
                    </template>
                    <v-time-picker
                      v-if="dialog_destination_hour"
                      format="24hr"
                      color="blue-grey lighten-2"
                      v-model="travel.destination.hour"
                      full-width
                      @click:minute="$refs.menu.save(destination_time)"
                      :rules="[(value) => !!value || $t('rules.required')]"
                    ></v-time-picker>
                  </v-menu>
                </v-flex>

                <v-flex xs12 class="name">{{ $t("persons.label") }}</v-flex>

                <v-flex xs12 md12>
                  <v-layout row wrap>
                    <v-flex xs4 md4 class="item">
                      <v-select
                        attach
                        v-model="personType"
                        :multiple="false"
                        :items="personOptions"
                        :item-text="'name'"
                        item-value="value"
                        :label="'params.type' | i18n"
                        :disabled="false"
                        @change="search = ''"
                        ref="paxType"
                      ></v-select>
                    </v-flex>

                    <v-flex xs8 md8 class="item">
                      <v-autocomplete
                        v-model="autocompleteResult"
                        :items="search_values"
                        :loading="is_searching"
                        :search-input.sync="search"
                        clearable
                        hide-details
                        hide-selected
                        item-text="data.name"
                        item-value="data.id"
                        label="Introduce el nombre"
                        :disabled="personType == ''"
                        @change="addPeople()"
                        return-object
                      >
                        <template v-slot:no-data>
                          <v-list-tile>
                            {{ $t("no_results") }}
                          </v-list-tile>
                        </template>
                        <template v-slot:item="{ item }">
                          <template v-if="item.type == 'person'">
                            <v-list-item-avatar
                              style="
                                line-height: 0px;
                                width: 30px;
                                background-color: blue;
                                border-radius: 100%;
                                margin-right: 15px;
                                text-align: center;
                                color: white;
                                padding: 15px 0px;
                              "
                            >
                              {{ item.data.name.charAt(0) }}
                            </v-list-item-avatar>
                            <v-list-item-content>
                              <v-list-item-title>{{
                                item.data.name
                              }}</v-list-item-title>
                            </v-list-item-content>
                          </template>
                          <template v-else-if="item.type == 'team'">
                            <v-list-item-avatar
                              style="
                                line-height: 0px;
                                width: 30px;
                                margin-right: 15px;
                                text-align: center;
                                overflow: hidden;
                              "
                            >
                              <v-img :src="item.data.shield"></v-img>
                            </v-list-item-avatar>
                            <v-list-item-content>
                              <v-list-item-title
                                >{{ item.data.name }}
                                <b
                                  >({{ item.data.category_max_age }})</b
                                ></v-list-item-title
                              >
                            </v-list-item-content>
                          </template>
                        </template>
                        <template v-slot:no-data>
                          <v-list-tile>
                            {{ $t("no_results") }}
                          </v-list-tile>
                        </template>
                      </v-autocomplete>
                    </v-flex>
                  </v-layout>
                </v-flex>

                <v-flex xs12 md12>
                  <div class="person_list">
                    <div
                      style="
                        padding-bottom: 10px;
                        width: 100%;
                        border-bottom: 1px solid #777;
                      "
                    >
                      {{ $t("params.n_pax") }}
                    </div>
                    <div
                      class="item empty"
                      v-if="Object.values(travel.people).length == 0"
                    >
                      <div class="row">
                        <div class="content">
                          {{ $t("params.pax_empty") }}
                        </div>
                      </div>
                    </div>

                    <div
                      class="item"
                      v-for="(item, index) in travel.people"
                      :key="item.id"
                    >
                      <div class="row">
                        <div class="avatar">
                          <v-img
                            v-if="item.entity_type == '2'"
                            :src="item.shield"
                          ></v-img>
                          <span class="letter" v-else>{{
                            item.name.charAt(0)
                          }}</span>
                        </div>
                        <div class="content">
                          <template v-if="item.entity_type == 2">
                            <span>{{ item.name }} </span>
                            <b>({{ item.category_max_age }})</b>
                          </template>

                          <template v-else-if="item.entity_type == 3">
                            <span>{{ item.name }}</span>
                          </template>

                          <div class="options">
                            <div class="number">
                              <v-icon>person</v-icon>{{ item.number }}
                            </div>
                            <div class="actions">
                              <v-icon @click="deletePeople(index)"
                                >delete</v-icon
                              >
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="pax">
                    <v-flex xs12 md12 class="item">
                      <span class="label"
                        >{{ $t("total") }} {{ $t("params.n_pax") }}:</span
                      >
                      <v-text-field
                        type="number"
                        v-model="travel.pax"
                      ></v-text-field>
                    </v-flex>
                  </div>
                </v-flex>

                <v-flex xs12 md12 class="item">
                  <v-text-field
                    :label="'params.observations' | i18n"
                    :value="travel['observations'] | checkParam"
                    @change="(v) => (travel['observations'] = v)"
                    outline
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 md12 class="item">
                  <v-text-field
                    :label="'params.observations_int' | i18n"
                    :value="travel['observations_int'] | checkParam"
                    @change="(v) => (travel['observations_int'] = v)"
                    outline
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import i18n from "@/i18n";

import Table from "@/components/ui/Table";
import Topbar from "@/components/ui/Topbar";
import ClipperImage from "@/components/ui/ClipperImage";

import { Api } from "@/core/api.js";
const api = new Api();

export default {
  name: "FormTravel",
  components: { Table, Topbar, ClipperImage },
  props: { page: String, action: String },
  data() {
    return {
      // Initialize travel with safe defaults to avoid undefined access in template
      travel: {
        type: '',
        travel_number: null,
        transport_company: '',
        origin: {
          entity_type: '',
          entity_id: '',
          name: null,
          address: null,
          city: null,
          date: null,
          hour: null,
          coordinates: null,
          latitud: null,
          longitud: null
        },
        destination: {
          entity_type: '',
          entity_id: '',
          name: null,
          address: null,
          city: null,
          date: null,
          hour: null,
          coordinates: null,
          latitud: null,
          longitud: null
        },
        people: [],
        transport_mode: null,
        pax: 0,
        status: '',
        bus_private: false
      },
      // FORM VARIABLES
      valid: true,
      data_loaded: false,
      originType: null,
      destinationType: null,
      peopleArrayLoad: [],
      peopleLoaded: {},
      dataLoaded: false,
      people: "",
      // FORM TYPE OPTIONS
      statusOptions: [
        { value: "1", name: i18n.t("travels.status.1") },
        { value: "2", name: i18n.t("travels.status.2") },
      ],
      personOptions: [
        { value: "team", name: i18n.t("travels.person_type.team") },
        { value: "person", name: i18n.t("travels.person_type.person") },
      ],
      locationOptions: [
        { value: "4", name: i18n.t("hotels.label") },
        { value: "5", name: i18n.t("facilitys.label") },
        { value: "11", name: i18n.t("travels.other_location") },
        { value: "0", name: i18n.t("travels.custom_location") },
      ],
      // AUTOCOMPLETE
      autocompletes: {},
      param_autocomplete: false,
      toAutoComplete: null,
      // SEARCHER
      personType: "",
      search: this.string,
      search_filter_entity: false,
      search_list: false,
      search_values: [],
      is_searching: false,
      autocompleteResult: "",
      // VUETIFY DATEPICKERS & HOURPICKERS
      dialog_origin_date: false,
      dialog_origin_hour: false,
      dialog_destination_date: false,
      dialog_destination_hour: false,
      origin_time: null,
      destination_time: null,
    };
  },
  computed: {
    nextTravelID() {
      return parseInt(this.$store.getters["travels/getNextTravelID"]());
    },

    transport_modes() {
      var oOptions = this.$store.getters.getTransportMode();
      var aResult = [];
      for (var k in oOptions) {
        aResult.push({
          name: i18n.t("travels.transport_mode." + oOptions[k].name),
          id: oOptions[k].id,
        });
      }
      return aResult;
    },

    originLocations() {
      switch (this.originType) {
        case "4":
          return this.$store.getters["hotels/getList"]();
        case "5":
          return this.$store.getters["facilitys/getList"]();
        case "11":
          return this.$store.getters["travels/getLocations"]();
        default:
          return [];
      }
    },

    destinationLocations() {
      switch (this.destinationType) {
        case "4":
          return this.$store.getters["hotels/getList"]();
        case "5":
          return this.$store.getters["facilitys/getList"]();
        case "11":
          return this.$store.getters["travels/getLocations"]();
        default:
          return [];
      }
    },

    travelTypes() {
      const getter = this.$store.getters['getTravelTypes']
      if (!getter) return []
      const raw = getter()
      if (!raw) return []
      const list = Array.isArray(raw) ? raw : Object.values(raw)
      return list.map(type => ({
        value: String(type.id),
        name: i18n.t(type.name)
      }))
    }
  },
  watch: {
    // call again the method if the route changes
    $route: "loadDataPage",
    search: {
      handler(val) {
        var self = this;
        this.search_filter_entity = false;
        if (val != null && val.trim() == "") {
          self.search_list = false;
          self.search_values = [];
        } else if (val != null && val.length >= 1) {
          self.search_list = true;

          self.search_values = [];
          if (val.trim() == "") {
            self.search_list = false;
          } else {
            self.search_list = true;
            self.is_searching = true;
            var event = self.$store.getters.isEventSelected
              ? self.$store.getters["events/getCurrentEvent"]()
              : false;
            var path = "search/" + val.trim();
            path = event ? path + "/event/" + event.id : path;
            path = self.personType ? path + "/" + self.personType : path;
            api.get(path).then(function (response) {
              if (response.status) {
                var data = response.data;
                var aResult = [];
                data.forEach((item) => {
                  if (item.type == "person") {
                    if (item.data.role.club != null) {
                      item.data.rel = {
                        type: "club",
                        name: item.data.role.club.name,
                        shield: item.data.role.club.shield,
                        role: item.data.role.contact_type.name,
                      };
                    } else if (item.data.role.team != null) {
                      item.data.rel = {
                        type: "team",
                        name: item.data.role.team.name,
                        shield: item.data.role.team.shield,
                        role: item.data.role.contact_type.name,
                      };
                    } else {
                      item.data.rel = false;
                    }
                  }
                });

                self.is_searching = false;
                self.search_values = data;
              } else {
                self.is_searching = false;
              }
            });
          }
        }
      },
      deep: true,
    },

    people: {
      handler(val) {
        if (this.dataLoaded) {
          var result = 0;
          if (this.travel.people != undefined) {
            for (var item in this.travel.people) {
              result += this.travel.people[item].number;
            }
          }
          this.travel.pax = result;
        }
      },
      deep: true,
    },
  },
  created() {
    this.loadDataPage();
  },
  methods: {
    loadDataPage() {
      this.$overlay.loading();
      var self = this;
      var params = {};
      if (self.$store.state.event_selected) {
        params.event = self.$store.getters["events/getCurrentEvent"]().id;
      }
      this.$store.dispatch("travels/loadLocations", params).then(function () {
        var fullPage = self.page.replace("event_", "");
        var page = self.page.replace("event_", "").split("_")[0];
        var oParams = { ...self.$route.params };
        if (self.$store.state.event_selected) {
          oParams.event = self.$store.getters["events/getCurrentEvent"]().id;
        }

        oParams.id = self.$route.params.id;
        // EDIT
        if (typeof oParams.id !== "undefined") {
          self.$store.dispatch(page + "/load_by_id", oParams).then(function () {
            self.travel = {
              ...self.$store.getters[page + "/get_by_id"](oParams.id),
            };
            self.ensureTravelStructure();
            self.peopleArrayLoad = [...Object.values(self.travel.people)];
            self.travel.people = [];
            self.originType = self.travel.origin.entity_type;
            self.destinationType = self.travel.destination.entity_type;
            self.travel.bus_private = parseInt(self.travel.bus_private) == 1;

            self.formatOriginDate();
            self.formatDestinationDate();

            self.loadPeople();
          });
        }
        // ADD
        else {
          // Reset using default structure
          const base = self.defaultTravel();
          base.travel_number = self.$store.getters['travels/getNextTravelID']();
          // Provide sample default dates if desired
          base.origin.date = '2024-03-26';
          base.destination.date = '2024-03-31';
          self.travel = base;

          if (
            self.$route.params.entity_type == 2 &&
            self.$route.params.entity_id
          ) {
            var team = self.$store.getters["teams/get_by_id"](
              self.$route.params.entity_id
            );
            var iNumPersonWithHotel = 0;
            /*for (var k in team.players) {
              if (parseInt(team.players[k].modality) == 1) {
                iNumPersonWithHotel++;
              }
            }
            for (var k in team.staff) {
              if (parseInt(team.staff[k].modality) == 1) {
                iNumPersonWithHotel++;
              }
            }
            for (var k in team.acompanyants) {
              if (parseInt(team.acompanyants[k].modality) == 1) {
                iNumPersonWithHotel++;
              }
            }*/
           if(team.mode == 1 || team.mode == "Z1NjenJhTWxQSmdjVkYwVG1JMVMrZz09"){
            iNumPersonWithHotel = parseInt(team.estimate_players) + parseInt(team.estimate_staff) + parseInt(team.estimate_acompanyants);
           }
            var oPeople = {
              entity_type: 2,
              entity_id: team.id,
              name: team.name,
              category_name: team.category.max_age,
              shield: team.club.shield,
              category_max_age: team.category.max_age,
              number: iNumPersonWithHotel,
            };
            self.travel.pax = oPeople.number;
            self.travel.people.push(oPeople);
          }

          self.dataLoaded = true;
          self.$overlay.hide();
        }
      });
    },
    // Returns a fresh default travel object
    defaultTravel() {
      return {
        type: '',
        travel_number: null,
        transport_company: '',
        origin: {
          entity_type: '',
          entity_id: '',
          name: null,
          address: null,
          city: null,
          date: null,
          hour: null,
          coordinates: null,
          latitud: null,
          longitud: null
        },
        destination: {
          entity_type: '',
          entity_id: '',
          name: null,
          address: null,
          city: null,
          date: null,
          hour: null,
          coordinates: null,
          latitud: null,
          longitud: null
        },
        people: [],
        transport_mode: null,
        pax: 0,
        status: '',
        bus_private: false
      };
    },
    // Ensures origin/destination objects exist (for older saved entities)
    ensureTravelStructure() {
      if (!this.travel) this.travel = this.defaultTravel();
      if (!this.travel.origin) this.travel.origin = this.defaultTravel().origin;
      if (!this.travel.destination) this.travel.destination = this.defaultTravel().destination;
      // if (!Array.isArray(this.travel.people)) this.travel.people = [];
    },

    cleanPlace(place, newValue) {
      this.travel[place] = {
        entity_type: "",
        entity_id: "",
        name: null,
        address: null,
        city: null,
        date: "",
        coordinates: null,
      };

      this.travel[place].entity_type = newValue;

      place == "origin"
        ? (this.travel.parsedOriginDate = "")
        : (this.travel.parsedDestinationDate = "");
    },

    formatOriginDate() {
      if (this.travel.origin.date != null) {
        this.travel.parsedOriginDate = moment(this.travel.origin.date).format(
          "DD/MM/YYYY"
        );
      } else {
        this.travel.parsedOriginDate = null;
      }
    },

    formatDestinationDate() {
      if (this.travel.destination.date != null) {
        this.travel.parsedDestinationDate = moment(
          this.travel.destination.date
        ).format("DD/MM/YYYY");
      } else {
        this.travel.parsedDestinationDate = null;
      }
    },

    addPeople() {
      var item = this.autocompleteResult;

      if (this.personType == "team") {
        var self = this;
        this.$store
          .dispatch("teams/load_by_id", { id: item.data.id })
          .then(function (team) {
            var iNumPersonWithHotel = 0;
            // for (var k in team.players) {
            //   if (parseInt(team.players[k].modality) == 1) {
            //     iNumPersonWithHotel++;
            //   }
            // }
            // for (var k in team.staff) {
            //   if (parseInt(team.staff[k].modality) == 1) {
            //     iNumPersonWithHotel++;
            //   }
            // }
            // for (var k in team.acompanyants) {
            //   if (parseInt(team.acompanyants[k].modality) == 1) {
            //     iNumPersonWithHotel++;
            //   }
            // }
            if(team.mode == 1 || team.mode == "Z1NjenJhTWxQSmdjVkYwVG1JMVMrZz09"){
                iNumPersonWithHotel = parseInt(team.estimate_players) + parseInt(team.estimate_staff) + parseInt(team.estimate_acompanyants);
            }
            var oPeople = {
              entity_type: 2,
              entity_id: item.data.id,
              name: item.data.name,
              category_name: item.data.category_max_age,
              category_max_age: item.data.category_max_age,
              shield: item.data.shield,
              number: iNumPersonWithHotel,
            };
            self.travel.people.push(oPeople);
            self.people = self.travel.people;
          });
      } else {
        var oPeople = {
          entity_type: 3,
          entity_id: item.data.id,
          name: item.data.name,
          category_name: "",
          shield: "",
          number: 1,
        };
        this.travel.people.push(oPeople);
        this.people = this.travel.people;
      }

      this.search = "";
    },

    deletePeople(index) {
      this.travel.people.splice(index, 1);
      this.people = this.travel.people;
    },

    fnAction(emit) {
      if (typeof emit.action === "undefined" || emit.action == null) return;
      switch (emit.action) {
        case "save":
          this.fnSave();
          break;
      }
    },

    fnSave() {
      var item = this.travel;
      // if ( item.origin.date == null || item.origin.hour == null || item.destination.date == null || item.destination.hour == null) {
      //   this.$popup.alert({
      //     message: i18n.t( "travels.datehour_error_form" ),
      //     btnSuccess: i18n.t( "accept" )
      //   });
      // }

      if (
        (item.origin.entity_type == "4" ||
          item.origin.entity_type == "5" ||
          item.origin.entity_type == "11") &&
        (item.origin.entity_id == "" || item.origin.entity_id == null)
      ) {
        this.$popup.alert({
          message: i18n.t("travels.origin_entity_error_form"),
          btnSuccess: i18n.t("accept"),
        });
      } else if (
        (item.destination.entity_type == "4" ||
          item.destination.entity_type == "5" ||
          item.destination.entity_type == "11") &&
        (item.destination.entity_id == "" || item.destination.entity_id == null)
      ) {
        this.$popup.alert({
          message: i18n.t("travels.destination_entity_error_form"),
          btnSuccess: i18n.t("accept"),
        });
      } else if (item.type == null || item.type == "") {
        this.$popup.alert({
          message: i18n.t("travels.type_error_form"),
          btnSuccess: i18n.t("accept"),
        });
      } else if (item.transport_mode == null || item.transport_mode == "") {
        this.$popup.alert({
          message: i18n.t("travels.transportmode_error_form"),
          btnSuccess: i18n.t("accept"),
        });
      } else if (item.contact_name == null || item.contact_name == "") {
        this.$popup.alert({
          message: i18n.t("travels.contactname_error_form"),
          btnSuccess: i18n.t("accept"),
        });
      } else if (item.contact_phone == null || item.contact_phone == "") {
        this.$popup.alert({
          message: i18n.t("travels.contactphone_error_form"),
          btnSuccess: i18n.t("accept"),
        });
      } else if (this.$refs.form.validate()) {
        var self = this;
        var page = this.page.replace("event_", "").split("_")[0];
        var fullPage = this.page.replace("event_", "");
        var event = self.$store.getters.isEventSelected
          ? self.$store.getters["events/getCurrentEvent"]()
          : false;

        this.travel.parsedPeople = JSON.stringify(this.travel.people);
        this.travel.parsedOrigin = JSON.stringify(this.travel.origin);
        this.travel.parsedDestination = JSON.stringify(this.travel.destination);
        this.travel.bus_private = this.travel.bus_private ? 1 : 0;

        var travel = { ...this.travel };

        this.$overlay.loading();

        this.$store
          .dispatch("travels/upload", { data: travel, event: event.id })
          .then(function (idEntity) {
            page = event ? "event_" + page : page;
            self.$router.push({
              name: page + "_card",
              params: {
                id: idEntity,
                event: event
                  ? self.$root
                      .formatEventUrl(event.name, event.edition)
                      .replace("/event/", "")
                  : null,
              },
            });
          });
      } else {
        this.$popup.alert({
          message: i18n.t("exists_error_on_form"),
          btnSuccess: i18n.t("accept"),
        });
      }
    },

    loadPeople() {
      if (Object.keys(this.peopleArrayLoad).length > 0) {
        var key = Object.keys(this.peopleArrayLoad)[
          Object.keys(this.peopleArrayLoad).length - 1
        ];
        var item = this.peopleArrayLoad[key];

        if (item.entity_type == "2") {
          var self = this;
          this.$store
            .dispatch("teams/load_by_id", { id: item.entity_id })
            .then(function (team) {
              var iNumPersonWithHotel = 0;
              for (var k in team.players) {
                if (parseInt(team.players[k].modality) == 1) {
                  //   console.log("PLAYER -> ", team.players[k].name);
                  iNumPersonWithHotel++;
                }
              }
              for (var k in team.staff) {
                if (parseInt(team.staff[k].modality) == 1) {
                  iNumPersonWithHotel++;
                }
              }
              for (var k in team.acompanyants) {
                if (parseInt(team.acompanyants[k].modality) == 1) {
                  iNumPersonWithHotel++;
                }
              }
              var oTeam = {
                entity_type: 2,
                entity_id: item.entity_id,
                name: team.name,
                category_name: team.category.max_age,
                category_max_age: team.category.max_age,
                shield: team.club.shield,
                number: iNumPersonWithHotel,
              };
              self.travel.people.push(oTeam);
              self.loadPeople();
            });
        } else {
          var self = this;
          this.$store
            .dispatch("persons/load_by_id", { id: item.entity_id })
            .then(function (person) {
              var oPerson = {
                entity_type: 3,
                entity_id: item.entity_id,
                name: person.name,
                category_name: "",
                shield: "",
                number: 1,
              };
              self.travel.people.push(oPerson);
              self.loadPeople();
            });
        }
        this.peopleArrayLoad.pop();
      } else {
        this.$overlay.hide();
        this.dataLoaded = true;
      }
    },
  },
  filters: {
    checkParam(value) {
      return value != null ? value : "";
    },

    formatType(value) {
      switch (value) {
        case null:
          return "";
          break;
        case 1:
          return "Administrador Backoffice";
          break;
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
#formTravel {
  width: 100%;
  display: inline-block;
  height: 100%;
  overflow-y: auto;
  padding-bottom: 100px;

  .container {
    width: 80%;
    width: calc(100% - 350px);
    padding: 0px;

    &.center {
      margin: 0 auto;
    }

    .name {
      margin-top: 25px;
      font-size: 22px;
      border-bottom: 2px solid;
      /*cursor: pointer;*/
      -webkit-touch-callout: none;
      -webkit-user-select: none;
      -khtml-user-select: none;
      -moz-user-select: none;
      -ms-user-select: none;
      user-select: none;

      /*&::after {
                    content: "";
                    width: 20px;
                    height: 20px;
                    background: url(/img/down.svg);
                    background-repeat: no-repeat;
                    background-size: 20px;
                    background-position: center right;
                    position: absolute;
                    transition-duration: 0.2s;
                    margin-left: 10px;
                }
                
                &.hidden {
                    &::after {
                        transform: rotate(180deg);
                        transition-duration: 0.2s;
                    }
                }*/
    }

    .clear {
    }

    .role {
      padding: 0;

      .container {
        margin: 0;
        width: 100%;

        .name {
          font-size: 18px;
          color: #685f5f;
        }
      }
    }

    .section-container {
      padding: 20px;

      &#basic {
        background-color: #fff;
        @include box-shadow($h: 0px, $v: 3px, $b: 8px, $s: 0px, $c: #00000011);
      }
      &#notes {
        background-color: $complem-color-light;
      }
      &#teams {
        background-color: #fff;
        @include box-shadow($h: 0px, $v: -3px, $b: 8px, $s: 0px, $c: #00000011);
      }

      .item.flex {
        padding: 0 20px;

        .image {
          // width: 40%;
          float: left;
          padding: 0 40px;

          img,
          .addthumb {
            width: 150px;
            border: 1px solid #ccc;
            height: 150px;
            position: relative;
            cursor: pointer;
          }

          .addthumb div {
            width: 100%;
            display: block;
            top: 35%;
            position: absolute;
            text-align: center;
          }
          .addthumb .text {
            top: 60%;
          }
        }

        .name {
          position: relative;

          .remove {
            width: fit-content;
            float: right;
          }

          .add {
            background-image: url(/img/add_b.svg);
            background-size: 15px;
            background-repeat: no-repeat;
            background-position: left center;
            position: absolute;
            right: 0;
            top: 15px;
            padding-left: 20px;
            text-transform: none;
            font-weight: bold;
            cursor: pointer;
          }
        }

        .v-input:not(.v-input--radio-group) .v-input__slot {
          border: none;
          border-bottom: 2px solid rgba(0, 0, 0, 0.14);
          border-radius: 0;
          padding-left: 0;
        }

        .v-input__prepend-inner {
          margin-top: 25px;
        }

        .v-input.upper input {
          text-transform: uppercase;
        }
      }

      .v-menu__content {
      }
      .v-select {
        label {
          top: 0px;
          padding-left: 0;
          font-size: 18px;
          /*display: none;*/
        }
      }
    }
  }

  .person_list {
    border-bottom: 1px solid #777;

    .item {
      width: 100%;
      margin: 0 auto;
      border-bottom: 1px solid #ddd;

      &:last-of-type {
        border: none;
      }

      .row {
        width: 100%;
        height: 50px;

        .avatar {
          width: 20%;
          display: inline-block;
          float: left;
          line-height: 3;

          .v-image {
            margin: 7.5px;
            height: 35px;
            width: 35px;
          }

          .letter {
            line-height: 0px;
            background-color: blue;
            border-radius: 100%;
            text-align: center;
            color: white;
            padding: 10px 15px;
            margin: 6px;
          }
        }
        .content {
          height: 50px;
          width: 80%;
          display: inline-block;
          line-height: 50px;
          overflow: hidden;

          .options {
            float: right;
            display: inline-block;
            line-height: 3;

            .number {
              width: 60px;
              float: left;
              display: inline-block;
              line-height: 3;
            }

            .actions {
              display: inline-block;
              float: right;
              line-height: 3;
              cursor: pointer;
            }
          }
        }
      }
    }
  }

  .pax {
    line-height: 50px;
    height: 50px;

    .item {
      margin: 0 auto;
      float: right !important;

      .label {
        display: inline-block;
      }

      .v-input {
        display: inline-block;
        width: 60px;
        text-align: center;

        input {
          text-align: center;
        }
      }
    }
  }
}

.empty {
  .row {
    height: 50px;
    text-align: center;
    .content {
      height: 50px;
      line-height: 50px;
      width: 100%;
      margin: 0 auto;
      float: none;
      text-align: center;
      color: #444;
    }
  }
}
</style>
